export default __webpack_public_path__ + "static/media/arrow-again.9efdc3f4.svg";